import React from "react";
import { CatalogueItem } from "lib/types";
import { useState } from "react";
import {
  getDetectedMessages,
  getExtrasTooltip,
  getProhibitedItemsTooltip,
  getProhibitedItems,
  getRedirectItemsTooltip,
  RedirectItem,
} from "lib/helpers/tooltipHelper";
import { WasteDescriptionTooltip } from "components/WasteDescriptionTooltip/WasteDescriptionTooltip";
import { useCallback } from "react";

export interface UseTooltipReturn {
  Tooltip: () => React.ReactElement;
  updateTooltip: (
    description: string,
    formSurcharges: Record<string, number>,
  ) => void;
  surchargeItems: string[];
  detectedMessages: string[];
  prohibitedItems: string[];
  redirectItems: RedirectItem[];
  isDisabled: boolean;
}

export interface UseTooltipProps {
  surcharges: CatalogueItem[];
  categorySku: string;
}

export const useTooltip = ({
  categorySku,
  surcharges,
}: UseTooltipProps): UseTooltipReturn => {
  const [isDisabled, setDisabled] = useState(false);
  const [surchargeItems, setSurchargeItems] = useState<string[]>([]);
  const [prohibitedItems, setProhibitedItems] = useState<string[]>([]);
  const [redirectItems, setRedirectItems] = useState<RedirectItem[]>([]);
  const [detectedMessages, setDetectedMessages] = useState<string[]>([]);

  const isSkipJob = categorySku === "SKIPS";

  const updateTooltip: UseTooltipReturn["updateTooltip"] = useCallback(
    (description, formSurcharges) => {
      if (
        isDisabled &&
        !surchargeItems.length &&
        !prohibitedItems.length &&
        !redirectItems.length &&
        !detectedMessages.length
      ) {
        return;
      }

      setSurchargeItems(
        getExtrasTooltip(description, formSurcharges, surcharges),
      );
      setDetectedMessages(getDetectedMessages(description, categorySku));
      setProhibitedItems(
        getProhibitedItemsTooltip(description, getProhibitedItems(isSkipJob)),
      );
      setRedirectItems(getRedirectItemsTooltip(description, categorySku));
    },
    [],
  );

  const resetTooltip = () => {
    setSurchargeItems([]);
    setDetectedMessages([]);
    setProhibitedItems([]);
    setRedirectItems([]);
  };

  return {
    Tooltip: () => (
      <WasteDescriptionTooltip
        onClose={resetTooltip}
        onDisable={() => setDisabled(true)}
        {...{
          isDisabled,
          surchargeItems,
          detectedMessages,
          prohibitedItems,
          redirectItems,
        }}
      />
    ),
    updateTooltip,
    isDisabled,
    surchargeItems,
    detectedMessages,
    prohibitedItems,
    redirectItems,
  };
};
